import { customFormat, parseCalendarDate } from 'utils/dateUtils'

export const formatExtendCollectionPeriodToast = ({ collectingUntil } = {}) => {
  const date = parseCalendarDate(collectingUntil)
  if (!date) {
    return 'Collection period extended.'
  }
  return `Collection period extended to ${customFormat(date, 'd MMM')}.`
}
